import { getInteractionsMultiAggregates, GetInteractionsMultiAggregatesParams } from '@/services/api';
import { useQuery } from 'react-query';

export const useGetInteractionsMultiAggregates = (props: GetInteractionsMultiAggregatesParams, enabled = true) => {
    const { dateRange, from, to, group_by_groups, agent_ids, variables, isPublic, shareId } = props;

    return useQuery({
        queryKey: [
            'interactions-multi-aggregates',
            {
                dateRange,
                from: from.toISOString(),
                to: to.toISOString(),
                group_by_groups,
                agent_ids,
                variables,
                isPublic,
                shareId,
            },
        ],
        queryFn: () => getInteractionsMultiAggregates(props),
        enabled,
    });
};
